export default "__VITE_ASSET__DLUVm0rM__"